<template>
  <div class="insurance-page">
    <!-- 投保表单主内容区 -->
    <main class="insurance-main">
      <div class="container">
        <div class="page-title">
          <h1>意外险补充保额投保</h1>
          <p>请填写以下信息完成投保申请，带 <span class="required">*</span> 为必填项</p>
        </div>

        <el-form
          ref="insuranceForm"
          :model="insuranceForm"
          :rules="rules"
          label-width="150px"
          class="insurance-form"
          :disabled="isSubmitting"
        >
          <!-- 投保基本信息 -->
          <div class="form-section">
            <h2 class="section-title"><i class="fa fa-info-circle"></i> 投保基本信息</h2>

            <el-row :gutter="20">
              <el-col :span="24" :md="12">
                <el-form-item label="起保日期" prop="beginTime">
                  <el-date-picker
                    v-model="insuranceForm.beginTime"
                    type="date"
                    @change="handleDaysChange"
                    placeholder="选择起保日期"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions">
                  </el-date-picker>
                </el-form-item>
              </el-col>

              <el-col :span="24" :md="12">
                <el-form-item label="投保月数" prop="period">
                  <el-select v-model="insuranceForm.period" placeholder="请选择投保月数"
                             @change="handleDaysChange">
                    <el-option v-for="amount in insuranceMonthsList" :key="amount.name" :label="amount.name"
                               :value="amount.name"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="24" :md="12">
                <el-form-item label="终保日期" prop="endDate">
                  <el-date-picker
                    v-model="insuranceForm.endDate"
                    type="date"
                    placeholder="终保日期"
                    disabled>
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 保额设置 -->
          <div class="form-section">
            <h2 class="section-title"><i class="fa fa-shield"></i> 保额设置</h2>

            <el-row :gutter="20">
              <el-col :span="24" :md="12">
                <el-form-item label="意外身故保额（万）" prop="deathCoverage">
                  <el-select v-model="insuranceForm.deathCoverage" placeholder="请选择意外身故保额">
                    <el-option v-for="amount in deathCoverageOptions" :key="amount" :label="amount + '0万'"
                               :value="amount"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="24" :md="12">
                <el-form-item label="意外伤残保额（万）" prop="disabilityCoverage">
                  <el-select v-model="insuranceForm.disabilityCoverage" placeholder="请选择意外伤残保额（可选）">
                    <el-option v-for="amount in disabilityCoverageOptions" :key="amount" :label="amount + '0万'"
                               :value="amount"></el-option>
                    <el-option label="不投保"  :value="''"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="24" :md="12">
                <el-form-item label="意外医疗保额（万）" prop="medicalCoverage">
                  <el-select v-model="insuranceForm.medicalCoverage" placeholder="请选择意外医疗保额（可选）">
                    <el-option v-for="amount in medicalCoverageOptions" :key="amount" :label="amount + '万'"
                               :value="amount"></el-option>
                    <el-option label="不投保"  :value="''"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <!-- 重要提示 -->
              <div style="color: #f56c6c; font-weight: bold; padding: 10px 0; margin-bottom: 20px;">
                重要提示:意外身故及意外伤残累计保额之和不超过100万!
<!--                <div v-if="totalAccidentalCoverage > 0" style="margin-top: 5px; color: #606266;">-->
<!--                  当前累计保额: {{ totalAccidentalCoverage }}万-->
<!--                  <span v-if="isCoverageExceeded" style="color: #f56c6c;">(已超过限制，请调整保额)</span>-->
<!--                </div>-->
              </div>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="24" :md="24">
                <el-form-item label="意外医疗赔偿标准（如投保）" label-width="200px" style="text-align: left;width: 100%;">
                  <span style="display: block; text-align: left;">{{ "意外医疗费用每次事故绝对免赔额为人民币200元。扣除免赔额后，对社保范围内合理医疗费用按90%的比例在保单限额内赔付，非社保范围内医疗费用不予赔偿。" }}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 投保人信息 -->
          <div class="form-section">
            <h2 class="section-title"><i class="fa fa-user-circle"></i> 投保人信息</h2>

            <el-row :gutter="20">
              <el-col :span="24" :md="12">
                <el-form-item label="企业（投保人）名称" prop="appliRealName">
                  <el-input v-model="insuranceForm.appliRealName" placeholder="请输入企业名称,与营业执照中名称一致"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="24" :md="12">
                <el-form-item label="证件类型" prop="appliIdType">
                  <el-select disabled v-model="insuranceForm.appliIdType" placeholder="请输入企业名称">
                    <el-option label="统一信用代码" value="统一信用代码"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">

              <el-col :span="24" :md="12">
                <el-form-item label="证件号码" prop="appliIdCard">
                  <el-input
                    v-model="insuranceForm.appliIdCard"
                    placeholder="请输入有效证件号"
                    @blur="validateIdCard"
                  ></el-input>
                  <div v-if="idCardValidationMessage" class="validation-message">{{ idCardValidationMessage }}</div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="详细地址" prop="address">
                  <el-input v-model="insuranceForm.address" placeholder="请输入详细地址"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="24" :md="12">
                <el-form-item label="联系人手机号" prop="appliContactPhone">
                  <el-input
                    v-model="insuranceForm.appliContactPhone"
                    placeholder="请输入联系人手机号"
                    maxlength="11"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24" :md="12">
                <el-form-item label="电子邮箱" prop="appliEmail">
                  <el-input v-model="insuranceForm.appliEmail" placeholder="请输入电子邮箱,填写后收取电子保单"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 发票模块 -->
                    <div class="form-section">
                      <h2 class="section-title"><i class="fa fa-user-circle"></i> 发票信息</h2>
                      <el-form-item label="发票类型" prop="invoiceType">
                        <el-radio-group v-model="invoiceType">
                          <el-radio-button label="0">不需要发票</el-radio-button>
                          <el-radio-button label="2">增值税普通发票</el-radio-button>
                          <el-radio-button label="1">增值税专用发票</el-radio-button>
                        </el-radio-group>
                      </el-form-item>

                      <!-- 普通发票和专用发票共有的字段 -->
                      <div v-if="invoiceType == 1 || invoiceType == 2">
                        <el-form-item label="公司名称" prop="taxpayerName">
                          <el-input v-model="insuranceForm.taxpayerName" placeholder="请输入公司名称"
                                    maxlength="100"></el-input>
                        </el-form-item>

                        <el-form-item label="纳税人识别号" prop="taxpayerId">
                          <el-input v-model="insuranceForm.taxpayerId" placeholder="请输入纳税人识别号"
                                    maxlength="20"></el-input>
                        </el-form-item>

                        <el-form-item label="邮箱地址" prop="taxEmail">
                          <el-input v-model="insuranceForm.taxEmail" placeholder="请输入邮箱地址"
                                    maxlength="50"></el-input>
                        </el-form-item>

                        <el-form-item label="联系电话" prop="mobile">
                          <el-input v-model="insuranceForm.mobile" placeholder="请输入联系电话"
                                    maxlength="11"></el-input>
                        </el-form-item>
                      </div>

                      <!-- 专用发票特有字段 -->
                      <div v-if="invoiceType == 1">
                        <el-form-item label="税务登记电话" prop="taxRegisterTel">
                          <el-input v-model="insuranceForm.taxRegisterTel" placeholder="请输入税务登记电话"
                                    maxlength="11"></el-input>
                        </el-form-item>
                        <el-form-item label="开户银行" prop="depositeBankName">
                          <el-input v-model="insuranceForm.depositeBankName" placeholder="请输入开户银行"
                                    maxlength="100"></el-input>
                        </el-form-item>

                        <el-form-item label="银行账号" prop="accountNo">
                          <el-input v-model="insuranceForm.accountNo" placeholder="请输入银行账号"
                                    maxlength="50"></el-input>
                        </el-form-item>

                        <el-form-item label="税务登记地址" prop="taxRegisterAddress">
                          <el-input v-model="insuranceForm.taxRegisterAddress" placeholder="请输入税务登记地址"
                                    maxlength="200"></el-input>
                        </el-form-item>
                      </div>
                    </div>

          <!-- 人员清单上传 -->
          <div class="form-section">
            <h2 class="section-title"><i class="fa fa-users"></i> 人员清单</h2>

            <el-form-item label="人员清单上传" prop="excelFile" :error="excelFileError">
              <div style="clear: both; text-align: left; margin-bottom: 10px;">

                <el-button
                  type="default"
                  @click="downloadConfirmationTemplate('人员清单.xls')"
                  icon="el-icon-download"
                  size="medium"
                >
                  下载模板
                </el-button>
              </div>

              <el-upload
                class="upload-demo"
                action=""
                :auto-upload="false"
                :on-change="handleExcelFileChange"
                :file-list="excelFileList"
                :on-remove="handleExcelFileRemove"
                :limit="1"
                accept=".xlsx,.xls"
                :on-exceed="handleExcelFileExceed"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="upload-tip">
                  请上传包含参保人员信息的Excel，支持的字段：投保人员姓名、性别、身份证号码、年龄、工种
                  <br>系统将自动验证清单字段格式
                </div>
              </el-upload>

              <div v-if="fileValidationErrors.length > 0" style="margin-top: 10px;">
                <el-alert
                  title="清单验证错误"
                  type="error"
                  :closable="false"
                >
                  <ul>
                    <li v-for="(error, index) in fileValidationErrors" :key="index">{{ error }}</li>
                  </ul>
                </el-alert>
              </div>
            </el-form-item>
          </div>

          <!-- 附件上传 -->
          <div class="form-section">
            <h2 class="section-title"><i class="fa fa-file-text"></i> 附件上传</h2>

            <el-form-item label="投保确认书" prop="wordFile" :error="wordFileError">
              <!-- 调整按钮位置，使其显示在标签下一行并保持左对齐 -->
              <div style="clear: both; text-align: left; margin-bottom: 10px;">
                <!--                              <el-button-->
                <!--                                type="default"-->
                <!--                                @click="downloadConfirmationTemplate('投保确认书模板示例.docx')"-->
                <!--                                icon="el-icon-download"-->
                <!--                                size="medium"-->
                <!--                              >-->
                <!--                                下载模板示例-->
                <!--                              </el-button>-->
                <el-button
                  type="default"
                  @click="downloadConfirmationTemplate('安得智联物流园区补充保额投保确认书.docx')"
                  icon="el-icon-download"
                  size="medium"
                >
                  下载模板
                </el-button>
              </div>

              <el-upload
                class="upload-demo"
                action=""
                :auto-upload="false"
                :on-remove="handleWordFileRemove"
                :file-list="wordFileList"
                accept=".docx,.doc"
                :limit="1"
                :on-change="handleWordFileChange"
                :on-exceed="handleWordFileExceed"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="upload-tip">请上传盖章版《投保确认书》（文件大小不超过7MB），支持DOC格式</div>
              </el-upload>
            </el-form-item>
          </div>

          <!-- 营业执照上传 -->
          <div class="form-section">
            <h2 class="section-title"><i class="fa fa-file-text"></i> 营业执照上传</h2>

            <el-form-item label="营业执照" prop="wordFileSecond" :error="wordFileSecondError">
              <el-upload
                class="upload-demo"
                action=""
                :auto-upload="false"
                :on-remove="handleWordFileSecondRemove"
                :limit="1"
                :file-list="wordFileSecondList"
                :on-change="handleWordFileSecondChange"
                :on-exceed="handleWordFileSecondExceed">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="upload-tip">请上传《营业执照》（文件大小不超过7MB）</div>
              </el-upload>
            </el-form-item>
          </div>

          <!-- 其他投保材料上传 -->
          <div class="form-section">
            <h2 class="section-title"><i class="fa fa-file-text"></i> 其他投保材料上传</h2>

            <el-form-item label="其他投保材料" prop="wordFileThird" :error="wordFileThirdError">
              <el-upload
                class="upload-demo"
                action=""
                :auto-upload="false"
                :on-remove="handleWordFileThirdRemove"
                :limit="1"
                :file-list="wordFileThirdList"
                :on-change="handleWordFileThirdChange"
                :on-exceed="handleWordFileThirdExceed">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="upload-tip">请上传其他投保材料（文件大小不超过7MB）</div>
              </el-upload>
            </el-form-item>
          </div>

          <!-- 提交按钮 -->
          <div class="form-actions">
            <el-button
              type="primary"
              @click="submitForm"
              :loading="isSubmitting"
            >
              <i v-if="isSubmitting" class="fa fa-spinner fa-spin"></i>
              提交投保单
            </el-button>
            <el-button
              @click="resetForm"
              :disabled="isSubmitting"
            >
              重置
            </el-button>
          </div>
        </el-form>
      </div>
    </main>
  </div>
</template>

<script>
import {resultEICurlHead, service} from '../../utils/axios'
import * as XLSX from 'xlsx'
import {getToken} from '../../utils/auth'

export default {
  name: 'andeCreateInsEICSuppSum',
  data () {
    return {
      // 导航相关状态
      isMobile: false,
      showMobileMenu: false,
      showLoginModal: false,
      showBackToTop: false,
      isSubmitting: false,
      resultEICurl: '',
      externalUrl: resultEICurlHead + 'resultEICSuppSum?id=', // 内嵌页面的URL

      // 表单验证消息
      idCardValidationMessage: '',
      dateRangeError: '',
      // 保额选项
      deathCoverageOptions: [1, 2, 3, 4, 5, 6], // 10万一档，10-60万
      insuranceMonthsList: [
        {name: '15天', value: 15},
        {name: '1个月', value: 1},
        {name: '2个月', value: 2},
        {name: '3个月', value: 3},
        {name: '4个月', value: 4},
        {name: '5个月', value: 5},
        {name: '6个月', value: 6},
        {name: '7个月', value: 7},
        {name: '8个月', value: 8},
        {name: '9个月', value: 9},
        {name: '10个月', value: 10},
        {name: '11个月', value: 11},
        {name: '12个月', value: 12}
      ],
      disabilityCoverageOptions: [1, 2, 3, 4, 5, 6], // 10万一档，10-60万
      medicalCoverageOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20], // 1万一档，1-20万
      invoiceType: 0,
      // 投保表单数据
      insuranceForm: {
        beginTime: '', // 起保日期
        endDate: '', // 终保日期
        deathCoverage: null, // 意外身故保额（万）
        disabilityCoverage: null, // 意外伤残保额（万）
        medicalCoverage: null, // 意外医疗保额（万）
        appliRealName: '', // 企业名称
        idType: 'unifiedCreditCode', // 证件类型，默认统一社会信用代码
        appliIdType: '统一信用代码',
        address: '',
        appliIdCard: '', // 证件号码
        contactPerson: '', // 联系人
        appliContactPhone: '', // 联系人手机号
        appliEmail: '', // 电子邮箱
        excelFile: null, // 人员清单
        wordFile: null, // 投保确认书
        wordFileSecond: null, // 营业执照
        wordFileThird: null, // 其他投保材料
        period: '12个月', // 投保月数
        taxEmail: '',
        taxRegisterTel: '', // 税务登记电话
        mobile: '', // 联系电话
        // 专用发票额外信息
        depositeBankName: '', // 开户银行
        companyName: '', // 企业名称
        taxPayerNo: '',
        taxRegisterAddress: '',
        accountNo: '', // 银行账号
        taxpayerName: '', // 纳税人名称
        taxpayerId: '' // 纳税人识别号
      },
      excelFileList: [], // 用于上传组件显示已选文件
      wordFileList: [], // 用于上传组件显示已选文件
      wordFileSecondList: [], // 用于上传组件显示已选文件
      wordFileThirdList: [], // 用于上传组件显示已选文件

      // 文件上传错误信息
      excelFileError: '',
      wordFileError: '',
      wordFileSecondError: '',
      wordFileThirdError: '',
      fileValidationErrors: [],
      pickerOptions: {
        disabledDate: (date) => {
          // 获取今天的日期并设置时间为23:59:59:999
          const today = new Date()
          today.setHours(23, 59, 59, 999)
          // 如果选择的日期小于等于今天，则禁用
          return date <= today
        }
      },

      // 表单验证规则
      rules: {
        beginTime: [
          {required: true, message: '请选择起保日期', trigger: 'blur'}
        ],
        period: [
          {required: true, message: '请选择投保月数', trigger: ['change', 'blur']}
        ],
        deathCoverage: [
          {required: true, message: '请选择意外身故保额', trigger: 'change'}
        ],
        // disabilityCoverage: [
        //   {type: 'number', min: 1, max: 6, message: '意外伤残保额范围在10万到60万之间', trigger: 'change'}
        // ],
        medicalCoverage: [
          {type: 'number', min: 1, max: 20, message: '意外医疗保额范围在1万到20万之间', trigger: 'change'}
        ],
        appliRealName: [
          {required: true, message: '请输入企业名称', trigger: 'blur'},
          {min: 2, max: 100, message: '企业名称长度在2到100个字符之间', trigger: 'blur'}
        ],
        idType: [
          {required: true, message: '请选择证件类型', trigger: 'change'}
        ],
        address: [
          {required: true, message: '请输入详细地址', trigger: 'blur'},
          {min: 5, message: '地址长度不能少于5个字符', trigger: 'blur'}
        ],
        appliIdCard: [
          {required: true, message: '请输入证件号码', trigger: 'blur'}
        ],
        contactPerson: [
          {required: true, message: '请输入联系人姓名', trigger: 'blur'},
          {min: 2, max: 50, message: '联系人姓名长度在2到50个字符之间', trigger: 'blur'}
        ],
        appliContactPhone: [
          {required: true, message: '请输入联系人手机号', trigger: 'blur'}
          // ,{pattern: /^1[3-9]\d{9}$/, message: '请输入有效的手机号', trigger: 'blur'}
        ],
        appliEmail: [
          {type: 'email', message: '请输入有效的电子邮箱', trigger: 'blur'}
        ],
        excelFile: [
          {required: true, message: '请上传人员清单文件', trigger: ['change', 'blur']}
        ],
        wordFile: [
          {required: true, message: '请上传投保确认书', trigger: ['change', 'blur']}
        ],
        wordFileSecond: [
          {required: true, message: '请上传营业执照', trigger: ['change', 'blur']}
        ],
        taxpayerName: [
          {required: true, message: '请输入公司名称', trigger: 'blur'}
        ],
        taxpayerId: [
          {required: true, message: '请输入纳税人识别号', trigger: 'blur'}
        ],
        taxEmail: [
          {required: true, message: '请输入发票邮寄地址', trigger: 'blur'}
        ],
        taxRegisterTel: [
          {required: true, message: '请输入税务登记电话', trigger: 'blur'},
          {pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur'}
        ],
        mobile: [
          {required: true, message: '请输入联系电话', trigger: 'blur'},
          {pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur'}
        ],
        depositeBankName: [
          {required: true, message: '请输入开户银行', trigger: 'blur'}
        ],
        accountNo: [
          {required: true, message: '请输入银行账号', trigger: 'blur'}
        ],
        taxRegisterAddress: [
          {required: true, message: '请输入税务登记地址', trigger: 'blur'}
        ]
      }
    }
  },
  computed: {
    // 判断是否为产品页（导航栏选中状态）
    isProductPage () {
      return false // 投保页不是产品页
    },
    // 计算意外身故及意外伤残累计保额
    totalAccidentalCoverage () {
      const death = this.insuranceForm.deathCoverage || 0
      const disability = this.insuranceForm.disabilityCoverage || 0
      return death * 10 + disability * 10 // 转换为实际金额（万）
    },

    // 判断累计保额是否超过限制
    isCoverageExceeded () {
      return this.totalAccidentalCoverage > 100
    }
  },
  created () {
    // 从localStorage加载表单数据
    this.loadFormDataFromCache()
  },

  // 监听表单数据变化，保存到localStorage
  watch: {
    'insuranceForm': {
      handler (newVal) {
        // 排除无法序列化的文件对象
        const formDataToSave = { ...newVal }
        delete formDataToSave.excelFile
        delete formDataToSave.wordFile
        delete formDataToSave.wordFileSecond
        delete formDataToSave.wordFileThird

        localStorage.setItem('insuranceFormCacheSuppSum', JSON.stringify({
          formData: formDataToSave,
          excelFileList: this.excelFileList.map(file => ({
            name: file.name,
            size: file.size,
            type: file.type,
            uid: file.uid
          })),
          wordFileList: this.wordFileList.map(file => ({
            name: file.name,
            size: file.size,
            type: file.type,
            uid: file.uid
          })),
          wordFileSecondList: this.wordFileSecondList.map(file => ({
            name: file.name,
            size: file.size,
            type: file.type,
            uid: file.uid
          })),
          wordFileThirdList: this.wordFileThirdList.map(file => ({
            name: file.name,
            size: file.size,
            type: file.type,
            uid: file.uid
          })),
          invoiceType: this.invoiceType
        }))
      },
      deep: true
    },

    // 监听保额变化，当累计保额超过限制时提示
    'insuranceForm.deathCoverage': function (newVal) {
      this.checkCoverageLimit()
    },

    'insuranceForm.disabilityCoverage': function (newVal) {
      this.checkCoverageLimit()
    }
  },
  methods: {
    checkCoverageLimit () {
      if (this.isCoverageExceeded) {
        this.$message.warning('意外身故及意外伤残累计保额之和超过100万，请调整保额')
      }
    },
    // 从localStorage加载表单数据
    loadFormDataFromCache () {
      try {
        const cachedData = localStorage.getItem('insuranceFormCacheSuppSum')
        if (cachedData) {
          const parsedData = JSON.parse(cachedData)
          if (parsedData.formData) {
            this.insuranceForm = { ...this.insuranceForm, ...parsedData.formData }
            this.invoiceType = parsedData.invoiceType || 0
            this.excelFileList = parsedData.excelFileList || []
            this.wordFileList = parsedData.wordFileList || []
            this.wordFileSecondList = parsedData.wordFileSecondList || []
            this.wordFileThirdList = parsedData.wordFileThirdList || []
            // 计算终保日期
            this.calculateEndDate()
          }
        }
      } catch (error) {
        console.error('加载缓存数据失败:', error)
      }
    },
    downloadConfirmationTemplate (fileName) {
      try {
        // 创建一个临时的a标签用于下载
        const link = document.createElement('a')
        // 设置下载文件的路径
        link.href = '/static/' + fileName
        link.download = fileName // 设置下载文件名
        // 触发点击事件开始下载
        document.body.appendChild(link)
        link.click()
        // 下载完成后移除a标签
        setTimeout(() => {
          document.body.removeChild(link)
        }, 100)
      } catch (error) {
        console.error('下载失败:', error)
        this.$message.error('文件下载失败，请检查文件是否存在')
      }
    },

    // 格式化日期为yyyy-MM-dd
    formatDate (date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },

    // 窗口大小变化处理
    handleResize () {
      this.isMobile = window.innerWidth <= 768
      if (!this.isMobile) this.showMobileMenu = false
    },

    // 滚动事件处理
    handleScroll () {
      this.showBackToTop = window.scrollY > 300
    },

    // 清除表单缓存
    clearFormCache () {
      localStorage.removeItem('insuranceFormCacheSuppSum')
    },

    // 返回顶部
    scrollToTop () {
      window.scrollTo({top: 0, behavior: 'smooth'})
    },

    // 验证日期范围不超过1年
    validateDateRange () {
      this.dateRangeError = ''

      if (!this.insuranceForm.beginTime || !this.insuranceForm.endTime) {
        return true
      }

      const begin = new Date(this.insuranceForm.beginTime)
      const end = new Date(this.insuranceForm.endDate)

      // 计算两个日期之间的天数差
      const timeDiff = end - begin
      const dayDiff = timeDiff / (1000 * 3600 * 24)

      // 超过365天则提示错误
      if (dayDiff > 365) {
        this.dateRangeError = '终保日期与起保日期之间不能超过1年'
        return false
      }

      return true
    },

    // 处理投保天数变化
    handleDaysChange () {
      // 重新计算终保日期
      this.calculateEndDate()
    },

    // 计算终保日期
    calculateEndDate () {
      console.log(this.insuranceForm.period)
      if (this.insuranceForm.beginTime && this.insuranceForm.period) {
        const start = new Date(this.insuranceForm.beginTime)
        // 修改为从正确的字段获取值
        const months = parseInt(this.insuranceForm.period)
        console.log(start)
        console.log(months)
        // 计算终保日期（起保日期 + 投保月数 - 1天，因为起保日当天也算一天）
        const end = new Date(start)

        // 正确处理日期溢出问题：先将日期设置为下个月的第一天，然后减1天
        // 这样可以确保像1月31日加1个月会正确计算到2月的最后一天
        end.setMonth(end.getMonth() + months)
        end.setDate(end.getDate() - 1)
        // 确保日期格式正确，避免直接赋值Date对象可能导致的显示问题
        this.insuranceForm.endDate = end.toISOString().split('T')[0]
      }
    },

    // 验证证件号码
    validateIdCard () {
      const id = this.insuranceForm.appliIdCard
      const type = this.insuranceForm.idType

      if (!id) {
        this.idCardValidationMessage = ''
        return
      }

      // 根据证件类型使用不同的验证规则
      if (type === 'unifiedCreditCode') {
        // 统一社会信用代码验证规则
        const creditCodeReg = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/
        if (!creditCodeReg.test(id)) {
          this.idCardValidationMessage = '请输入有效的统一社会信用代码'
        } else {
          this.idCardValidationMessage = ''
        }
      } else if (type === 'organizationCode') {
        // 组织机构代码验证规则
        const orgCodeReg = /^[0-9A-Z]{8}-[0-9A-Z]$/
        if (!orgCodeReg.test(id)) {
          this.idCardValidationMessage = '请输入有效的组织机构代码'
        } else {
          this.idCardValidationMessage = ''
        }
      } else if (type === 'businessLicense') {
        // 营业执照号码验证规则（较简单，实际应用中可能需要更复杂的验证）
        if (id.length < 15) {
          this.idCardValidationMessage = '请输入有效的营业执照号码'
        } else {
          this.idCardValidationMessage = ''
        }
      }
    },

    // 手动验证文件字段
    validateFileField (field) {
      this.$refs.insuranceForm.validateField(field, (errorMessage) => {
        if (errorMessage) {
          this[`${field}Error`] = errorMessage
        } else {
          this[`${field}Error`] = ''
        }
      })
    },

    // 提交表单
    async submitForm () {
      // 验证日期范围
      if (!this.validateDateRange()) {
        this.$message.error(this.dateRangeError)
        return
      }
      // 先检查累计保额是否超过限制
      if (this.isCoverageExceeded) {
        this.$message.error('意外身故及意外伤残累计保额之和超过100万，请调整保额')
        return
      }

      // 验证证件号码
      this.validateIdCard()
      if (this.idCardValidationMessage) {
        this.$message.error(this.idCardValidationMessage)
        return
      }
      console.log('===============112221====================', this.insuranceForm)
      const insuranceMonthsItem = this.insuranceMonthsList.find(item => item.name === this.insuranceForm.period)
      // 验证文件字段
      console.log('===============111====================', insuranceMonthsItem.value)
      this.validateFileField('excelFile')
      this.validateFileField('wordFile')
      this.validateFileField('wordFileSecond')
      this.validateFileField('wordFileThird')

      this.$refs.insuranceForm.validate(async (valid) => {
        if (valid) {
          try {
            await this.$confirm('确定要提交投保单吗？提交后将无法修改。', '确认提交', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })

            this.isSubmitting = true

            // 创建FormData对象处理multipart/form-data类型数据
            const formData = new FormData()

            // 添加请求参数（普通字段）
            formData.append('productId', '1948587670757298177')
            formData.append('channelId', '1752141505145974785')
            formData.append('beginTime', this.insuranceForm.beginTime)
            // formData.append('endDate', this.insuranceForm.endDate)
            // formData.append('deathCoverage', this.insuranceForm.deathCoverage)
            // formData.append('disabilityCoverage', this.insuranceForm.disabilityCoverage || '')
            // formData.append('medicalCoverage', this.insuranceForm.medicalCoverage || '')
            formData.append('appliIdCard', this.insuranceForm.appliIdCard)
            formData.append('address', this.insuranceForm.address)
            formData.append('appliEmail', this.insuranceForm.appliEmail)
            formData.append('appliRealName', this.insuranceForm.appliRealName)
            formData.append('contactPerson', this.insuranceForm.contactPerson)
            formData.append('appliContactPhone', this.insuranceForm.appliContactPhone)
            formData.append('period', this.insuranceForm.period)
            formData.append('insuranceMonths', insuranceMonthsItem.value)
            formData.append('invoiceType', this.invoiceType)

            formData.append('taxRegisterTel', this.insuranceForm.taxRegisterTel)
            formData.append('mobile', this.insuranceForm.mobile)
            formData.append('depositeBankName', this.insuranceForm.depositeBankName)
            formData.append('accountNo', this.insuranceForm.accountNo)
            formData.append('taxpayerName', this.insuranceForm.taxpayerName)
            formData.append('taxpayerId', this.insuranceForm.taxpayerId)
            formData.append('taxRegisterAddress', this.insuranceForm.taxRegisterAddress)
            formData.append('taxEmail', this.insuranceForm.taxEmail)

            // 生成保额数据JSON对象
            const coverageData = {
              DEATH: this.insuranceForm.deathCoverage || 0,
              MEDICAL: this.insuranceForm.medicalCoverage || 0,
              DISABILITY: this.insuranceForm.disabilityCoverage || 0
            }
            formData.append('coverageType', JSON.stringify(coverageData))
            // 添加文件
            if (this.insuranceForm.excelFile) {
              formData.append('excelFile', this.insuranceForm.excelFile)
            }
            if (this.insuranceForm.wordFile) {
              formData.append('wordFile', this.insuranceForm.wordFile)
            }
            if (this.insuranceForm.wordFileSecond) {
              formData.append('wordFileSecond', this.insuranceForm.wordFileSecond)
            }
            if (this.insuranceForm.wordFileThird) {
              formData.append('wordFileThird', this.insuranceForm.wordFileThird)
            }

            // 发送POST请求
            const res = await service.post(
              '/andeEIC/eicAccidentInsurance/andecreateInsEICSuppSum',
              formData,
              {
                headers: {
                  // const username = Vue.ls.get(USER_NAME)
                  // const accessToken = Vue.ls.get(ACCESS_TOKEN)
                  // const userInfo = Vue.ls.get(USER_INFO)
                  // const uiCacheDbDictData = Vue.ls.get(UI_CACHE_DB_DICT_DATA)
                  // console.log('用户名:', username)
                  // console.log('accessToken:', accessToken)
                  // console.log('userInfo:', userInfo)
                  // console.log('uiCacheDbDictData:', uiCacheDbDictData)
                  'x-access-token': getToken()
                  // 'x-sign': 'E19D6243CB1945AB4F7202A1B00F77D5'
                  // 当使用FormData时，浏览器会自动设置正确的Content-Type，包含boundary
                  // 不需要手动设置'Content-Type': 'multipart/form-data'
                },
                timeout: 100000
              }
            )

            console.log('投保提交结果:', res)

            if (res.success) {
              // 成功逻辑
              this.$message.success('投保申请提交成功')
              this.resultEICurl = res.result
              console.log('res.result:', this.resultEICurl)
              // 直接使用window.location.href跳转，不再使用内嵌页面
              // 清除表单缓存
              this.clearFormCache()
              // window.location.href = this.externalUrl + this.resultEICurl

              this.$router.push({
                path: '/SidebarMenu/anDeEICOrderList',
                query: { saleId: this.$route.query.saleId }
              }).then(() => {
                console.log('路由跳转成功')
              }).catch(err => {
                console.error('路由跳转失败:', err)
              })
              this.resetForm()
            } else {
              console.error('提交失败:', res)
              this.$message.error(`提交失败: ${res.message || '未知错误'}`)
            }
          } catch (error) {
            if (error.response && error.response.status === 401) {
              this.$message.error('登录过期，请重新登录')
              this.$router.push({path: '/login'})
            }
            console.error('请求发生错误:', error)
            // 取消确认也会触发catch，需要判断
            if (error !== 'cancel') {
              console.error('请求发生错误:', error.message)
              this.$message.error(error.message)
            }
          } finally {
            this.isSubmitting = false
          }
        } else {
          this.$message.error('表单填写存在错误，请检查')
          return false
        }
      })
    },

    // 重置表单
    resetForm () {
      console.log('------------')
      this.fileValidationErrors = []
      this.idCardValidationMessage = ''
      this.dateRangeError = ''
      this.insuranceForm.excelFile = null
      this.insuranceForm.wordFile = null
      this.insuranceForm.wordFileSecond = null
      this.insuranceForm.wordFileThird = null
      this.excelFileList = []
      this.wordFileList = []
      this.wordFileSecondList = []
      this.wordFileThirdList = []
      this.excelFileError = ''
      this.wordFileError = ''
      this.wordFileSecondError = ''
      this.wordFileThirdError = ''

      // 清除缓存
      this.clearFormCache()

      this.$refs.insuranceForm.resetFields()
    },

    // 处理文件超过数量限制
    async handleExcelFileExceed (fileList) {
      try {
        console.log('===============111====================')
        const latestFile = fileList[0]
        this.excelFileList = [latestFile]
        this.excelFileError = ''
        this.fileValidationErrors = []

        // 读取 Excel 文件
        const reader = new FileReader()
        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result)
          const workbook = XLSX.read(data, {type: 'array'})
          const firstSheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[firstSheetName]
          const jsonData = XLSX.utils.sheet_to_json(worksheet)

          // 验证表头
          const headerRow = XLSX.utils.sheet_to_json(worksheet, {header: 1})[0]
          const expectedHeaders = ['投保人员姓名', '性别', '身份证号码', '年龄', '工种']
          const isHeaderValid = headerRow.every((header, index) => header === expectedHeaders[index])

          if (!isHeaderValid) {
            this.excelFileError = 'Excel 表头格式不正确，请确保表头为：投保人员姓名\t性别\t身份证号码\t年龄\t工种'
            return
          }

          // 验证数据行数
          if (jsonData.length < 3) {
            this.excelFileError = 'Excel 数据至少需要 3 行'
          }
        }
        reader.readAsArrayBuffer(latestFile)
        this.insuranceForm.excelFile = latestFile
        this.validateFileField('excelFile')
      } catch (error) {
        console.error('文件读取错误:', error)
        this.excelFileError = '文件读取失败，请检查文件格式是否正确'
      }
    },

    // 处理文件超过数量限制
    handleWordFileExceed (fileList) {
      const latestFile = fileList[0]
      const fileToCheck = latestFile.raw || latestFile
      // 检查文件格式
      if (!fileToCheck.type || !fileToCheck.type.includes('msword')) {
        this.wordFileError = '仅支持DOC与DOCX格式'
        this.wordFileList = [] // 清空文件列表
        this.insuranceForm.wordFile = null
        return
      }
      console.log(latestFile)
      this.wordFileList = [latestFile]
      this.wordFileError = ''

      this.insuranceForm.wordFile = latestFile
      this.validateFileField('wordFile')
    },
    handleWordFileSecondExceed (fileList) {
      this.$message.warning(`每次只能上传一个文件，已自动替换为新文件`)
      const latestFile = fileList[0]
      this.insuranceForm.wordFileSecond = latestFile
      this.wordFileSecondList = [latestFile]
      this.wordFileSecondError = '' // 清除错误
    },
    handleWordFileThirdExceed (fileList) {
      this.$message.warning(`每次只能上传一个文件，已自动替换为新文件`)
      const latestFile = fileList[0]
      this.insuranceForm.wordFileThird = latestFile
      this.wordFileThirdList = [latestFile]
      this.wordFileThirdError = '' // 清除错误
    },

    async handleExcelFileChange (file) {
      try {
        console.log('===================================')
        this.insuranceForm.excelFile = file.raw
        this.excelFileList = [file]
        this.excelFileError = ''
        this.fileValidationErrors = []

        // 读取 Excel 文件
        const reader = new FileReader()
        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result)
          const workbook = XLSX.read(data, {type: 'array'})
          const firstSheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[firstSheetName]
          const jsonData = XLSX.utils.sheet_to_json(worksheet)

          // 验证表头
          const headerRow = XLSX.utils.sheet_to_json(worksheet, {header: 1})[0]
          const expectedHeaders = ['投保人员姓名', '性别', '身份证号码', '年龄', '工种']
          const isHeaderValid = headerRow.every((header, index) => header === expectedHeaders[index])

          if (!isHeaderValid) {
            this.excelFileError = 'Excel 表头格式不正确，请确保表头为：投保人员姓名\t性别\t身份证号码\t年龄\t工种'
            return
          }

          // 验证数据行数
          if (jsonData.length < 3) {
            this.excelFileError = 'Excel 数据至少需要 3 行'
          }
        }
        reader.readAsArrayBuffer(file.raw)
      } catch (error) {
        console.error('文件读取错误:', error)
        this.excelFileError = '文件读取失败，请检查文件格式是否正确'
      }
    },

    // 人员清单删除
    handleExcelFileRemove () {
      this.insuranceForm.excelFile = null
      this.excelFileList = []
      this.excelFileError = '请上传人员清单文件'
    },

    handleWordFileChange (file) {
      // 检查文件大小
      if (this.checkFileSize(file)) {
        this.insuranceForm.wordFile = file.raw
        this.wordFileList = [file]
        this.wordFileError = ''
        this.validateFileField('wordFile')
      } else {
        this.wordFileError = '文件大小不能超过5MB'
        this.wordFileList = [] // 清空文件列表
        this.insuranceForm.wordFile = null
      }
    },
    handleWordFileSecondChange (file) {
      // 检查文件大小
      if (this.checkFileSize(file)) {
        this.insuranceForm.wordFileSecond = file.raw
        this.wordFileSecondList = [file] // 强制只显示一个文件
        // 关键：文件变化时手动验证并清除错误
        this.wordFileSecondError = ''
        this.validateFileField('wordFileSecond')
      } else {
        this.wordFileSecondError = '文件大小不能超过5MB'
        this.wordFileSecondList = [] // 清空文件列表
        this.insuranceForm.wordFileSecond = null
      }
    },
    handleWordFileThirdChange (file) {
      // 检查文件大小
      if (this.checkFileSize(file)) {
        this.insuranceForm.wordFileThird = file.raw
        this.wordFileThirdList = [file] // 强制只显示一个文件
        // 关键：文件变化时手动验证并清除错误
        this.wordFileThirdError = ''
        this.validateFileField('wordFileThird')
      } else {
        this.wordFileThirdError = '文件大小不能超过5MB'
        this.wordFileThirdList = [] // 清空文件列表
        this.insuranceForm.wordFileThird = null
      }
    },

    // 投保确认书删除
    handleWordFileRemove () {
      this.insuranceForm.wordFile = null
      this.wordFileList = []
      this.wordFileError = '请上传投保确认书'
    },
    // 营业执照删除
    handleWordFileSecondRemove () {
      this.insuranceForm.wordFileSecond = null
      this.wordFileSecondList = [] // 清空列表
      // 关键：文件移除时手动设置错误
      this.wordFileSecondError = '请上传营业执照'
    },
    // 其他投保材料删除
    handleWordFileThirdRemove () {
      this.insuranceForm.wordFileThird = null
      this.wordFileThirdList = [] // 清空列表
      // 关键：文件移除时手动设置错误
      this.wordFileThirdError = '请上传其他投保材料'
    },

    // 验证Excel文件
    validateExcelFile (file) {
      // 文件大小限制
      const maxSize = 10 * 1024 * 1024 // 10MB
      if (file.size > maxSize) {
        this.fileValidationErrors = ['文件大小不能超过10MB']
        return false
      }

      // 清空之前的错误
      this.fileValidationErrors = []
      return true
    },
    // 检查文件大小是否超过5MB
    checkFileSize (file) {
      const maxSize = 7 * 1024 * 1024 // 7MB = 7 * 1024 * 1024 字节
      return file.size <= maxSize
    }
  }
}
</script>
<style scoped>
/* 页面基础样式 */
.insurance-page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #333;
  background-color: #f5f7fa;
}

/* 导航栏样式 */
.navbar {
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  transition: box-shadow 0.3s;
}

.navbar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  height: 70px;
  max-width: 1200px;
  margin: 0 auto;
}

.brand {
  font-size: 18px;
  font-weight: bold;
  color: #1890ff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 40%;
}

.desktop-menu {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

.desktop-menu li {
  margin-left: 30px;
}

.desktop-menu a {
  color: #666;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s;
  padding: 5px 0;
  position: relative;
}

.desktop-menu a:hover,
.desktop-menu .active a {
  color: #1890ff;
}

.desktop-menu .active a::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #1890ff;
}

.mobile-menu-btn {
  display: none;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  transition: color 0.3s;
}

.mobile-menu-btn:hover {
  color: #1890ff;
}

.mobile-menu {
  position: absolute;
  top: 70px;
  left: 0;
  right: 0;
  background-color: #fff;
  list-style: none;
  margin: 0;
  padding: 15px 0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transform-origin: top center;
  animation: menuFadeIn 0.3s ease-out;
  z-index: 1000;
}

@keyframes menuFadeIn {
  from {
    opacity: 0;
    transform: scaleY(0.9);
  }
  to {
    opacity: 1;
    transform: scaleY(1);
  }
}

.mobile-menu li {
  margin: 0;
  padding: 0 20px;
}

.mobile-menu a {
  display: block;
  color: #666;
  text-decoration: none;
  padding: 10px 0;
  border-bottom: 1px solid #f5f5f5;
  transition: color 0.3s;
}

.mobile-menu a:hover {
  color: #1890ff;
}

.mobile-menu li:last-child a {
  border-bottom: none;
}

/* 主内容区样式 */
.insurance-main {
  flex: 1;
  margin-top: 90px;
  margin-bottom: 60px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.page-title {
  margin-bottom: 40px;
  text-align: center;
}

.page-title h1 {
  color: #2c3e50;
  font-size: 28px;
  margin-bottom: 10px;
  position: relative;
  display: inline-block;
  padding-bottom: 10px;
}

.page-title h1::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background-color: #1890ff;
}

.page-title p {
  color: #666;
  font-size: 14px;
}

.required {
  color: #f56c6c;
}

/* 表单样式 */
.insurance-form {
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: box-shadow 0.3s;
}

.insurance-form:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.form-section {
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #f0f0f0;
}

.form-section:last-child {
  border-bottom: none;
  margin-bottom: 20px;
  padding-bottom: 0;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #1890ff;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  padding-left: 10px;
  border-left: 3px solid #1890ff;
}

.section-title i {
  margin-right: 8px;
}

.form-tip, .upload-tip {
  color: #606266;
  font-size: 12px;
  margin-top: 5px;
  line-height: 1.5;
}

.validation-message {
  color: #f56c6c;
  font-size: 12px;
  margin-top: 5px;
}

.form-actions {
  text-align: center;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
}

.form-actions .el-button {
  margin: 0 10px;
  min-width: 120px;
}

/* 页脚样式 */
.footer {
  background-color: #2c3e50;
  color: #fff;
  padding: 40px 0 20px;
  font-size: 14px;
  margin-top: auto;
}

.footer .container {
  text-align: center;
}

.footer p {
  margin-bottom: 20px;
  opacity: 0.8;
}

.footer-links {
  margin-bottom: 30px;
}

.footer-links a {
  color: #fff;
  text-decoration: none;
  margin: 0 10px;
  opacity: 0.8;
  transition: opacity 0.3s;
}

.footer-links a:hover {
  opacity: 1;
  text-decoration: underline;
}

/* 返回顶部按钮 */
.back-to-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #1890ff;
  color: white;
  border: none;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  font-size: 16px;
  transition: all 0.3s;
  opacity: 0;
  transform: translateY(20px);
}

.back-to-top.fade-in {
  opacity: 1;
  transform: translateY(0);
}

.back-to-top:hover {
  background-color: #096dd9;
  transform: scale(1.1);
}

/* 响应式调整 */
@media (max-width: 768px) {
  .desktop-menu {
    display: none;
  }

  .mobile-menu-btn {
    display: block;
  }

  .brand {
    font-size: 16px;
    max-width: 60%;
  }

  .page-title h1 {
    font-size: 24px;
  }

  .insurance-form {
    padding: 20px 15px;
  }

  .section-title {
    font-size: 15px;
  }

  .el-form-item {
    margin-bottom: 15px !important;
  }

  .el-form-item__label {
    font-size: 13px !important;
    padding: 10px 0 !important;
  }

  .form-actions {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .form-actions .el-button {
    width: 100%;
    margin: 0;
  }
}

/* 动画效果 */
.el-upload-list-item {
  transition: all 0.3s;
}

.el-upload-list-item:hover {
  transform: translateX(5px);
}
</style>



// WEBPACK FOOTER //
// src/views/anDeEIC/andeCreateInsEICSuppSum.vue